import type { SVGProps } from 'react'
const SvgSyCompass = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="M9.831 7.843c.85.458 3.097 1.764 3.901 3.157s.812 3.992.784 4.957a.233.233 0 0 1-.347.2c-.85-.458-3.097-1.764-3.901-3.157s-.812-3.992-.784-4.957a.233.233 0 0 1 .347-.2" />
	</svg>
)
export default SvgSyCompass
